import type { FC } from 'react';
import React from 'react';
import { Body, useFormatDate } from '@edreamsodigeo/prisma-design-system';
import { withErrorBoundary } from '@edreamsodigeo/frontend-core';

interface DateTimeCapitalizeProps {
  date: string;
  bodyType: 'xSmall';
  bodyColor: 'neutral.80';
}

const LAST_CHAR_ZERO_UTC = 'Z';
const DATE_FORMAT = 'EEE, dd MMM';

const DateTimeCapitalizeComponent: FC<DateTimeCapitalizeProps> = ({
  date,
  bodyType,
  bodyColor,
}) => {
  const formatDate = useFormatDate(DATE_FORMAT);

  let finalDate = '';

  if (date) {
    // Workaround to avoid adding a extra day to the date when the date is near to midnight
    // It is neccessary to check the last char of the date because in UTC+0 the date has just Z and the rest has the amount (2024-01-07T14:35:00+01:00 vs 2024-01-07T14:35:00Z)
    const lenghtDate = date.length;
    const lastCharDate = date.charAt(lenghtDate - 1);

    const dateWithoutUTC =
      lastCharDate !== LAST_CHAR_ZERO_UTC
        ? date.slice(0, -6)
        : date.slice(0, -1);

    const dateFormat = formatDate(dateWithoutUTC);
    finalDate = dateFormat.charAt(0).toUpperCase() + dateFormat.slice(1);
  }
  return (
    <Body type={bodyType} color={bodyColor as string} inline>
      {finalDate}
    </Body>
  );
};

export default withErrorBoundary(DateTimeCapitalizeComponent, {
  name: 'DateTimeCapitalize',
});
